import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import AutoComplete from 'material-ui/AutoComplete';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
const dataSourceConfig = {
    text: 'title',
    value: 'id',
};
class HistoryRevision extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            search: [],
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            historyRev: [],
            er_title: ''
        };
        this.getSearchERNumber = this.getSearchERNumber.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    handleUpdateInput = (searchText) => {
        console.log(searchText)
        this.setState({
            searchText: searchText,
        });
        this.getERNumber(searchText);
    };

    handleNewRequest = (searchText) => {
        this.getSearchERNumber();
    };

    enterKeyPress(event) {
        if (event.key == 'Enter') {
        }
    }

    getERNumber(searchText = '') {
        fetch(this.state.apiUrl + '/ErRest/getERNumber/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        search: findresponse.ers,
                        errorText: ''
                    })
                } else {
                    this.setState({ errorText: findresponse.msg })
                }

            })
    }
    getSearchERNumber() {
        fetch(this.state.apiUrl + '/ErRest/getSearchERNumber/userAuthKey/' + this.state.userAuthKey + '/search/' + this.state.searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        ers: findresponse.ers,
                        item_count: findresponse.item_count,
                    })
                    if (this.state.item_count > 0) {
                        window.location.href = '/viewER/' + findresponse.er_id;
                    }
                }
                else {
                    alert("No result found");
                }
            })
    }

    HistoryRevision() {
        fetch(this.state.apiUrl + '/ErRest/HistoryRevision/id/' + this.props.match.params.erId + '/userAuthKey/' + this.state.userAuthKey + '/type/' + this.props.match.params.type + '/rev/' + this.props.match.params.noteid)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.rawjsonparse(responseJson, 1);
                this.setState({
                    historyRev: responseJson.historyRev,
                    er_title: responseJson.er_title,
                })
            })
    }

    componentDidMount() {
        document.title = "Intranet | History Revision";
        this.HistoryRevision();
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div >
                <Header brecum_name="ER's" brecum_page="History Revision" />
                <div class="right_col">
                    <div className="intranet_body">
                        <div class="title mob"><HeaderMob page_name="History Revision" /></div>
                        <div class="form-group">
                            <div class="react_auto">
                                <MuiThemeProvider muiTheme={getMuiTheme()}>
                                    <AutoComplete
                                        floatingLabelText="Search ticket number"
                                        onUpdateInput={this.handleUpdateInput}
                                        onNewRequest={this.handleNewRequest}
                                        fullWidth={true}
                                        placeholder='Search ER ID or Title'
                                        filter={AutoComplete.caseInsensitiveFilter}
                                        dataSource={this.state.search}
                                        dataSourceConfig={dataSourceConfig}
                                        errorText={this.state.errorText}
                                        maxSearchResults={8}
                                        onKeyPress={this.enterKeyPress}
                                        errorStyle={{ bottom: 0 }}
                                        className="ticket_search_box"
                                    />
                                </MuiThemeProvider>
                                <i class="fa fa-search"></i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3 col-xs-12"><b>Summary </b></div>
                            <div class="col-md-6 col-xs-12"><div class="details_des" dangerouslySetInnerHTML={{ __html: this.props.match.params.erId + ' : ' + this.state.er_title }} /></div>
                        </div>
                        <br />
                        <hr></hr>
                        {/* loop start for revision  */}
                        {
                            this.state.historyRev.map((ErHistory, key) =>
                                <div>
                                    <div class="row">
                                        <div class="col-md-3 col-xs-12"><b>Revision </b></div>
                                        <div class="col-md-6 col-xs-12">{ErHistory.created_date} by {ErHistory.user_name}</div>
                                    </div>
                                    <br />
                                    <div class="row">
                                        <div class="col-md-3 col-xs-12"><b>{ErHistory.type == 1 ? 'Description' : (ErHistory.type == 4 ? 'Note' : '')}</b></div>
                                        <div class="details_des col-md-6"><div dangerouslySetInnerHTML={{ __html: ErHistory.value }} /></div>
                                    </div>
                                    <div class="row">
                                    <hr></hr>
                                    </div>
                                </div>
                            )
                        }

                        {/* loop end for revision  */}
                        <div class="top-row border-bottom hidden-xs">
                        <Link to={`/viewEr/${this.props.match.params.erId}`} name={"max"}> <button className="btn btn-blue hidden-sm" >Back</button></Link>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default HistoryRevision;


// WEBPACK FOOTER //
// ./src/components/er/HistoryRevision.js